import { IconType } from 'react-icons';
import { styled } from 'styled-components';
import { ProjectTemplate } from 'types';

const CardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;

  svg {
    font-size: 20px;
  }
  span {
    font-size: 16px;
    font-weight: 600;
  }
`;

const Card = styled.button`
  display: flex;
  flex-direction: column;
  padding: 16px;
  border: 1px solid ${(props) => props.theme.global.borderColor};
  border-radius: 6px;
  min-height: 152px;
  background-color: ${(props) => props.theme.global.bgColor};

  p {
    color: ${(props) => props.theme.global.lightTextColor};
    font-size: 14px;
    white-space: pre-wrap;
    text-align: left;
  }

  &:disabled {
    background-color: ${(props) => props.theme.ui.button.iconButtonBgColor};
  }

  &:not(:disabled):hover {
    outline: 2px solid ${(props) => props.theme.global.mainColor};
    ${CardHeader} {
      color: ${(props) => props.theme.global.mainColor};
    }
  }
`;

interface TemplateCardProps {
  template: ProjectTemplate;
  Icon: IconType;
  onTemplateClick: (templateId: string) => void;
}

const TemplateCard = ({ template, Icon, onTemplateClick }: TemplateCardProps) => {
  return (
    <Card key={template.id} onClick={() => onTemplateClick(template.id)} disabled={template.id !== 'free'}>
      <CardHeader>
        <Icon />
        <span>{template.title}</span>
      </CardHeader>
      <p>{template.description}</p>
    </Card>
  );
};

export default TemplateCard;
